// extracted by mini-css-extract-plugin
module.exports = {"productThumbnail":"style_productThumbnail__2yXyv"};